export default "__VITE_ASSET__1120ed43__"